export const shouldShowMoreBeVisible = (state, id) => {
  const { ui: { visibleMenuId = null } = {} } = state;
  return id === visibleMenuId;
};

export const isShowMoreVisible = (state) => {
  const { ui: { visibleMenuId } = {} } = state;
  return Boolean(visibleMenuId);
};

export const isShowCommunityMenu = (state) =>
  Boolean(state.ui.isVisibleCommunityMenu);

export const isShowMentionsModal = (state) =>
  Boolean(state.ui.isVisibleMentionsModal);

export const isShowCommunitySelectModal = (state) =>
  Boolean(state.ui.isVisibleCommunitySelectModal);

export default shouldShowMoreBeVisible;
